export default __webpack_public_path__ + "static/media/09ga.77f0ead1.png";